export default __webpack_public_path__ + "static/media/cp-color-removebg-preview.eb8e524d.png";